import React from 'react';
import './AdminTableSubCategories.scss';
//import {printQuizesCategory} from "../../../../../utils/helps.js";
import TableSubCategories from './TableSubCategories/TableSubCategories';
import { openAddInputFormsForSubCategories  } from '../../../adminSlice';

export default class AdminTableSubCategories extends React.Component {
    constructor(props) {
        super(props);

     this.onAdd = this.onAdd.bind(this);
    }


onAdd() {
    const { dispatch } = this.props;

    dispatch(openAddInputFormsForSubCategories());

}
    render() {
        let style;
            console.log(this.props.adminState.selectedCategory);
            if (this.props.adminState.selectedCategory) {
              
                    style = ''
                } else {
                    style = 'disabled'
                }

        const { dispatch} = this.props;
        return (
            
            <div className="AdminTableSubCategories">
                   <p className='tableName'>Список подкатегорий {this.props.adminState.selectedCategory} категории</p>

                   <TableSubCategories 
                   dispatch={dispatch}
                   data={this.props.adminState.dataSubCategoryId}
                   onClickSubcategory = {this.props.onClickSubcategory}
                   
                   />

                   <button className='addButton' onClick={this.onAdd} disabled={style} >{/*<i className="fas fa-plus"></i>*/}</button> 

                    


                
            </div>
        )
    }
}